import script from "./TalentRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./TalentRecord.vue?vue&type=script&setup=true&lang=js"

import "./TalentRecord.vue?vue&type=style&index=0&id=6951faff&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6951faff"]])

export default __exports__